/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './diaglab-pricing.reducer';

export const DiaglabPricingDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const diaglabPricingEntity = useAppSelector(state => state.diaglabPricing.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="diaglabPricingDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.diaglabPricing.detail.title">DiaglabPricing</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.diaglabPricing.id">Id</Translate>
            </span>
          </dt>
          <dd>{diaglabPricingEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.diaglabPricing.active">Active</Translate>
            </span>
          </dt>
          <dd>{diaglabPricingEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.diaglabPricing.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{diaglabPricingEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.diaglabPricing.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{diaglabPricingEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.diaglabPricing.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{diaglabPricingEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.diaglabPricing.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{diaglabPricingEntity.timestampentry}</dd>
          <dt>
            <span id="taxCode">
              <Translate contentKey="tinyMedicRestApp.diaglabPricing.taxCode">Tax Code</Translate>
            </span>
          </dt>
          <dd>{diaglabPricingEntity.taxCode}</dd>
          <dt>
            <span id="price">
              <Translate contentKey="tinyMedicRestApp.diaglabPricing.price">Price</Translate>
            </span>
          </dt>
          <dd>{diaglabPricingEntity.price}</dd>
          <dt>
            <span id="discount">
              <Translate contentKey="tinyMedicRestApp.diaglabPricing.discount">Discount</Translate>
            </span>
          </dt>
          <dd>{diaglabPricingEntity.discount}</dd>
          <dt>
            <span id="panel">
              <Translate contentKey="tinyMedicRestApp.diaglabPricing.panel">Panel</Translate>
            </span>
          </dt>
          <dd>{diaglabPricingEntity.panel ? 'true' : 'false'}</dd>
          <dt>
            <span id="addedByType">
              <Translate contentKey="tinyMedicRestApp.diaglabPricing.addedByType">Added By Type</Translate>
            </span>
          </dt>
          <dd>{diaglabPricingEntity.addedByType}</dd>
          <dt>
            <span id="addedByID">
              <Translate contentKey="tinyMedicRestApp.diaglabPricing.addedByID">Added By ID</Translate>
            </span>
          </dt>
          <dd>{diaglabPricingEntity.addedByID}</dd>
          <dt>
            <span id="modifiedByType">
              <Translate contentKey="tinyMedicRestApp.diaglabPricing.modifiedByType">Modified By Type</Translate>
            </span>
          </dt>
          <dd>{diaglabPricingEntity.modifiedByType}</dd>
          <dt>
            <span id="modifiedByID">
              <Translate contentKey="tinyMedicRestApp.diaglabPricing.modifiedByID">Modified By ID</Translate>
            </span>
          </dt>
          <dd>{diaglabPricingEntity.modifiedByID}</dd>
          <dt>
            <span id="multiplierApplied">
              <Translate contentKey="tinyMedicRestApp.diaglabPricing.multiplierApplied">Multiplier Applied</Translate>
            </span>
          </dt>
          <dd>{diaglabPricingEntity.multiplierApplied ? 'true' : 'false'}</dd>
          <dt>
            <span id="startDate">
              <Translate contentKey="tinyMedicRestApp.diaglabPricing.startDate">Start Date</Translate>
            </span>
          </dt>
          <dd>{diaglabPricingEntity.startDate}</dd>
          <dt>
            <span id="endDate">
              <Translate contentKey="tinyMedicRestApp.diaglabPricing.endDate">End Date</Translate>
            </span>
          </dt>
          <dd>{diaglabPricingEntity.endDate}</dd>
          <dt>
            <span id="suspended">
              <Translate contentKey="tinyMedicRestApp.diaglabPricing.suspended">Suspended</Translate>
            </span>
          </dt>
          <dd>{diaglabPricingEntity.suspended ? 'true' : 'false'}</dd>
          <dt>
            <span id="draft">
              <Translate contentKey="tinyMedicRestApp.diaglabPricing.draft">Draft</Translate>
            </span>
          </dt>
          <dd>{diaglabPricingEntity.draft ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diaglabPricing.diagLabPanel">Diag Lab Panel</Translate>
          </dt>
          <dd>{diaglabPricingEntity.diagLabPanel ? diaglabPricingEntity.diagLabPanel.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diaglabPricing.diagLab">Diag Lab</Translate>
          </dt>
          <dd>{diaglabPricingEntity.diagLab ? diaglabPricingEntity.diagLab.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diaglabPricing.labTestItem">Lab Test Item</Translate>
          </dt>
          <dd>{diaglabPricingEntity.labTestItem ? diaglabPricingEntity.labTestItem.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diaglabPricing.scheme">Scheme</Translate>
          </dt>
          <dd>{diaglabPricingEntity.scheme ? diaglabPricingEntity.scheme.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diaglabPricing.hospital">Hospital</Translate>
          </dt>
          <dd>{diaglabPricingEntity.hospital ? diaglabPricingEntity.hospital.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/diaglab-pricing" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/diaglab-pricing/${diaglabPricingEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DiaglabPricingDetail;
